import React from 'react';
import MapFull from "./MapFull";
import {TrackerEndpoints, TractorsEndpoints} from "../../common/ProxyEndpoints";

const MapAdmin = () => {

   return <MapFull showOwner={true}
                   getLocationsEndpoint={ () => TrackerEndpoints.getTrackersLocation() }
                   getTractorsUrl={ () => TractorsEndpoints.getUrl() }
                   sessionKey="maps_admin"/>
};

export default MapAdmin;


// WEBPACK FOOTER //
// ./src/views/Maps/MapAdmin.js